export default __webpack_public_path__ + "static/media/Mercenary's Gauntlets of the Untamed.982d7921.jpg";